// 动态译文管理：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 译文审核
export const management = Object.freeze({
  "businessTranslation.generated": "生成完成",
  "businessTranslation.autoPublish": "自動發佈已啟用：AI譯文校驗通過後顯示，無需人工審核。",
  "businessTranslation.sellerCompany": "貨主公司名稱",
  "businessTranslation.productTitle": "商品標題",
  "businessTranslation.mallGoodsId": "商城商品ID（goods_id）",
  "businessTranslation.title": "企業／商品正文譯文",
  "businessTranslation.hint":
    "動態譯文用於顯示，不改業務原文。啟用自動發佈時，AI譯文校驗通過後直接發佈；仍可人工修訂。",
  "businessTranslation.aiHint":
    "AI僅處理正文文字，不發送附件或HTML屬性；當前限8個文字節點、合計10000字符，較大正文請使用人工候選。",
  "businessTranslation.transferConfirmation":
    "我確認當前原文允許發送給已配置的翻譯模型（不包含未經授權的隱私或合同材料）",
  "businessTranslation.aiUnavailable":
    "生成配置未就緒或正文超出預算，人工候選仍可使用。",
  "businessTranslation.jobs": "最近20條正文生成任務",
  "businessTranslation.jobQueued":
    "已加入後台生成隊列，完成後按目前發佈策略顯示。",
  "businessTranslation.type": "正文類型",
  "businessTranslation.company": "企業介紹",
  "businessTranslation.product": "商品HTML正文",
  "businessTranslation.id": "真實企業／商品庫 ID",
  "businessTranslation.approve": "批准已審英文版本",
  "businessTranslation.preview":
    "目前介面語言的顯示預覽（HTML以原始碼文字顯示）",
  "businessTranslation.NOT_REQUESTED": "中文原文",
  "businessTranslation.NONE": "英文顯示譯文",
  "businessTranslation.TRANSLATION_MISSING": "暫無可用英文譯文，顯示原文",
  "businessTranslation.SOURCE_CHANGED": "原文已變，舊譯文不能用於顯示",
  "businessTranslation.SOURCE_UNLINKED": "尚無可靠的商品庫關聯，保留原文",
  "businessTranslation.TRANSLATION_UNAVAILABLE": "譯文暫不可用，保留原文",
  "contractTranslation.title": "合同譯文閲讀輔助台賬",
  "contractTranslation.hint":
    "僅供管理員核對原件與儲存閲讀輔助候選，不替代原合同。當前單管理員階段暫停獨立批准，不需要臨時創建審核賬號。",
  "contractTranslation.id": "真實合同 ID（非合同編號）",
  "contractTranslation.attachments": "關聯原件字節摘要",
  "contractTranslation.originalHint":
    "摘要不是附件正文。批准前須通過原合同入口核對真實附件、全部條款和關鍵事實；本頁面未提供不可變原件歸檔或 OCR 對照。",
  "contractTranslation.note": "審核意見（批准、拒絕均必填）",
  "contractTranslation.facts":
    "我已對照真實原件核驗金額、日期、編號、賬戶及全部條款，確認譯文僅為閲讀輔助",
  "contractTranslation.approve": "批准閲讀輔助（不公開發布）",
  "contractTranslation.empty": "暫無合同譯文候選",
  "contractTranslation.PENDING_REVIEW": "待獨立審核",
  "contractTranslation.REVIEWED": "已審核閲讀輔助",
  "contractTranslation.REJECTED": "已拒絕",
  "contractTranslation.independent":
    "不能審核自己提交的候選；當前單管理員階段獨立批准暫停",
  "contractTranslation.originalUnavailable":
    "真實原件暫不能完整核驗，不能提交或批准；可查看已有歷史候選",
  "contractTranslation.mismatch": "候選未保留關鍵事實，請核對原件並提交新候選",
  "contractTranslation.invalid": "請先讀取真實合同原件，並填寫英文候選",
  "contentTranslation.candidates": "最近20條候選（含人工候選）",
  "contentTranslation.title": "動態譯文管理",
  "contentTranslation.category": "商品分類説明",
  "contentTranslation.source": "當前中文原文",
  "contentTranslation.candidateSource": "候選綁定的原文",
  "contentTranslation.english": "英文候選",
  "contentTranslation.generate": "生成英文候選",
  "contentTranslation.manual": "儲存人工候選",
  "contentTranslation.refresh": "刷新任務",
  "contentTranslation.jobs": "最近20條生成任務",
  "contentTranslation.open": "對照審核",
  "contentTranslation.approve": "批准併發布",
  "contentTranslation.reject": "拒絕",
  "contentTranslation.note": "審核意見（拒絕時必填）",
  "contentTranslation.empty": "暫無生成任務",
  "contentTranslation.failed": "譯文操作失敗，請重試",
  "contentTranslation.saved": "候選已儲存，尚未公開",
  "contentTranslation.reviewed": "審核決定已儲存",
  "contentTranslation.queued": "任務已提交，請刷新查看生成結果",
  "contentTranslation.confirm":
    "請確認已核對術語、數字與料號。批准後，此版本譯文將用於公開英文顯示。",
  "contentTranslation.stale":
    "原文已變更或候選已終結，不能再次發佈。請為當前原文生成新候選。",
  "contentTranslation.disabled":
    "生成版本尚未配置；可儲存人工候選，不能猜測模型版本。",
  "contentTranslation.hint":
    "AI只生成待審候選；批准不會修改中文原文。此入口不處理合同或附件。",
  "contentTranslation.PENDING": "待生成",
  "contentTranslation.RUNNING": "生成中",
  "contentTranslation.GENERATED": "待審核",
  "contentTranslation.STALE": "原文已過期",
  "contentTranslation.FAILED": "生成失敗",
  "contentTranslation.PUBLISHED": "已發佈",
  "contentTranslation.REJECTED": "已拒絕",
  "contentTranslation.invalid": "請選擇有原文的分類並填寫英文候選",
});

export const messages = Object.freeze({ ...management });
